import cx from 'classnames';
import React, { TextareaHTMLAttributes } from 'react';

import s from './textarea.module.css';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    id: string;
    name: string;
    label?: string;
    errorText?: string;
    error?: boolean;
    wrapperClassName?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    (
        { id, name, label, errorText, error = false, className, wrapperClassName, ...props },
        ref
    ): JSX.Element => (
        <div className={cx(s.container, wrapperClassName)}>
            {label && (
                <label htmlFor={id} className={s.label}>
                    {label}
                </label>
            )}
            <textarea
                ref={ref}
                id={id}
                name={name}
                className={cx(
                    s.textarea,
                    {
                        [s.error]: error,
                    },
                    className
                )}
                {...props}
            />
            {error && errorText && <p className={cx(s.errorText, 'annotation')}>{errorText}</p>}
        </div>
    )
);

export default Textarea;
